import * as React from 'react';
import { createDrawerNavigator } from '@react-navigation/drawer';
import { FC, useEffect } from 'react';
import { AppState, StyleSheet, Text, View } from 'react-native';
import Colors from './../resources/Colors';
import AdjuvoAppBar from './../components/AppBar';
import { AgencyChatsScreen } from './Chat/AgencyChatsScreen';
import { Icon } from 'react-native-paper';
import { MyScheduleScreen } from './Configuration/MyScheduleScreen';
import { CustomDrawerContent } from './../components/DrawerContent';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getUserInfo, logout } from '../controller/authController';

// Crea el navegador del cajón. Usaremos uno solo.
const Drawer = createDrawerNavigator();

const UserActivityValidator = () => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector(state => state.auth);
  const lastValidation = React.useRef(Date.now());

  useEffect(() => {
    // 1. Si no hay userInfo en absoluto, disparamos la carga inicial
    if (!userInfo || userInfo.is_active === undefined) {
      dispatch(getUserInfo());
    }

    // 2. Lógica del listener para clics posteriores
    const validate = () => {
      const now = Date.now();
      // Solo validamos si han pasado más de 3 minutos desde la última vez
      if (now - lastValidation.current > 180000) {
        dispatch(getUserInfo());
        lastValidation.current = now;
      }
    };

    // Escuchamos clics en cualquier parte de la pantalla
    window.addEventListener('click', validate);
    return () => window.removeEventListener('click', validate);
  }, [userInfo, dispatch]);

  // --- EL TRUCO ESTÁ AQUÍ ---
  // Solo bloqueamos si el dato ya existe Y es explícitamente false.
  // Si es undefined (primera carga), lo dejamos pasar mientras la API responde.
  if (userInfo && userInfo.is_active === false) {
    // Aquí puedes disparar un logout o mostrar una pantalla de "Cuenta Suspendida"
    dispatch(logout(null));
  }

  return null; // No renderiza nada, solo ejecuta la lógica
};

const MainNavigationRoutes: FC<IRoute> = () => {

  return (
    <View style={{ flex: 1, overflow: 'hidden', width: '100vw' }}>
      <UserActivityValidator />
      <Drawer.Navigator
        drawerContent={(props) => <CustomDrawerContent {...props} />}
        //defaultStatus='open'
        screenOptions={({ navigation }) => ({
          headerShown: true,
          drawerActiveTintColor: Colors.textWhite,
          drawerInactiveTintColor: Colors.menuDark,
          // drawerHideStatusBarOnOpen: true,
          drawerStatusBarAnimation: 'slide',
          drawerStyle: styles.drawerContainer, // Estilos para el contenedor del drawer (cuando se usa deslizando)
          drawerType: 'front',
          //overlayColor: 'transparent',
          // Esto es muy importante para la Web
          sceneContainerStyle: {
            flex: 1,
            overflow: 'hidden', // Evita que el contenido "salido" cree scroll
            width: '100%',
            position: 'relative'
          },
          header: () => <AdjuvoAppBar navigation={navigation} />,
        })}
      >
        <Drawer.Screen name="Conversaciones" component={AgencyChatsScreen}
          options={{
            title: "Conversaciones - Cecy AI",
            drawerLabelStyle: styles.container,
            drawerLabel: 'Conversaciones', // Opcional: para cambiar el texto del ítem
            drawerIcon: ({ color, size }) => (
              <View style={styles.menuItemContent}>
                <Icon source="chat" color={Colors.textWhite} size={size} />
              </View>
            ),
          }} />
        <Drawer.Screen name="Horarios" component={MyScheduleScreen}
          options={{
            title: "Mis horarios - Cecy AI",
            drawerLabelStyle: styles.container,
            drawerLabel: 'Mis Horarios', // Opcional: para cambiar el texto del ítem
            drawerIcon: ({ color, size }) => (
              <View style={styles.menuItemContent}>
                <Icon source="calendar" color={Colors.textWhite} size={size} />
              </View>
            )
          }} />
        {/* ... otras pantallas ... */}
      </Drawer.Navigator>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row', // Para la disposición del menú permanente y el contenido
    overflow: 'hidden',   // Evita que cualquier desborde genere scroll
  },
  drawerContainer: {
    width: 240, // Ancho del drawer cuando se desliza
    backgroundColor: Colors.headerBlue, // Color de fondo del drawer
  },
  drawerActive: {
    color: Colors.textWhite
  },
  drawerItem: {
    color: Colors.menuDark
  },
  menuItemContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default MainNavigationRoutes;

